import React from 'react';
import { useCompanyContext } from '../Provider/CompanyProvider';
import SyncingOrErrorIndicator from '../../common/SyncingOrErrorIndicator';

const CompanyIsLoadingSpinner = () => {
    const {
        company: { loading }
    } = useCompanyContext();

    return <SyncingOrErrorIndicator isLoading={loading} />;
};

export default CompanyIsLoadingSpinner;
